import type { TreeMapSubFilterResetButtonProps } from "./tree-map-sub-filter-reset-button.type";

import { ReloadOutlined } from "@ant-design/icons";
import { Button } from "antd";

import { useTreeMap } from "../tree-map.context";

const TreeMapSubFilterResetButton = ({
  type,
  onClick,
}: TreeMapSubFilterResetButtonProps) => {
  const { subFilters, resetSubFilter } = useTreeMap();

  if (!subFilters[type]?.length) return null;

  return (
    <Button
      size="small"
      icon={<ReloadOutlined />}
      onClick={(e) => {
        resetSubFilter(type);
        onClick?.(e);
      }}
    />
  );
};

export default TreeMapSubFilterResetButton;
